module.exports = __webpack_public_path__ + "static/media/jumbocoin.38443eec.svg";